import { CaseFeedbackGuidanceMessage } from "types/graphql";
import { gql, useQuery } from "@apollo/client";

export const CASE_FEEDBACK_GUIDANCE_MESSAGES_QUERY = gql`
  query getCaseFeedbackGuidanceMessages {
    caseFeedbackGuidanceMessages {
      edges {
        node {
          title
          message
          code
        }
      }
    }
  }
`;

type CaseFeedbackGuidanceMessagesResult = {
  caseFeedbackGuidanceMessages: Array<CaseFeedbackGuidanceMessage>;
  isLoading: boolean;
};

export const useCaseFeedbackGuidanceMessages = (): CaseFeedbackGuidanceMessagesResult => {
  const { data, loading } = useQuery(CASE_FEEDBACK_GUIDANCE_MESSAGES_QUERY);
  const caseFeedbackGuidanceMessages =
    data?.caseFeedbackGuidanceMessages?.edges.map(({ node }: { node: CaseFeedbackGuidanceMessagesResult }) => node) ||
    [];

  return {
    caseFeedbackGuidanceMessages,
    isLoading: loading,
  };
};
